<nav
  id="header"
  class="bg-light d-flex justify-content-between align-items-center shadow-sm"
>
  <div class="header-line me-2 ms-1"></div>
  <div (click)="reloadPage()" class="m-2 cursor-pointer">
    <img
      [src]="'data:image/png;base64,' + tenant.branding.primaryLogoBase64"
      height="40"
      alt="image"
    />
  </div>
  <!-- <small class="w-100 d-flex justify-content-center"
      >TENANT: {{ tenant?.name.toUpperCase() }}</small
    > -->
  <div class="header-line me-1 ms-2"></div>
</nav>
<div class="login-bg d-flex mh-100 justify-content-center align-items-center">
  <div id="login-box" class="card bg-light shadow">
    <div
      class="card-header p-3 d-flex justify-content-center align-items-center"
    >
      <div class="fs-4">Log in</div>
    </div>
    <div class="card-body">
      <form [formGroup]="loginForm">
        <mat-form-field class="w-100 pt-2 ps-2 pe-2">
          <mat-label>Username</mat-label>
          <input
            matInput
            type="text"
            autocomplete="username"
            formControlName="username"
          />
        </mat-form-field>
        <mat-form-field class="w-100 pt-2 ps-2 pe-2">
          <mat-label>Password</mat-label>
          <input
            matInput
            autocomplete="current-password"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
          />
          <mat-icon matSuffix (click)="showPassword = !showPassword">{{
            showPassword ? 'visibility' : 'visibility_off'
          }}</mat-icon>
        </mat-form-field>
      </form>
      <div *ngIf="submitted" class="text-danger">
        <div
          *ngIf="username.errors?.required"
          class="alert alert-danger mt-3 me-4 ms-4 mb-0 d-flex justify-content-center"
        >
          Username is required
        </div>
        <div
          *ngIf="username.errors?.email"
          class="alert alert-danger mt-3 me-4 ms-4 mb-0 d-flex justify-content-center"
        >
          Username is not a valid email
        </div>
        <div
          *ngIf="password.errors?.required"
          class="alert alert-danger mt-3 me-4 ms-4 mb-0 d-flex justify-content-center"
        >
          Password is required
        </div>
      </div>
      <div
        *ngIf="error"
        class="alert alert-danger mt-3 me-4 ms-4 mb-0 d-flex justify-content-center"
      >
        {{ error }}
      </div>
      <div class="p-3 mt-1">
        <button
          class="w-100 btn btn-primary bg-fm-blue"
          (click)="login()"
          type="submit"
        >
          <span
            *ngIf="loggingIn"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ loggingIn ? 'Logging in...' : 'Log in' }}
        </button>
      </div>
      <div class="d-flex justify-content-center">
        <a (click)="apply()" class="cursor-pointer">Apply</a>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <a (click)="forgotPassword()" class="cursor-pointer">
          Forgot Password
        </a>
      </div>
    </div>
  </div>
</div>
